import {turnoService} from "../services/turnoService";
import moment from "moment";
moment.locale('es');

const initialState = {
  all: [],
  servicios: [],
  turnoItem: {},
  loadingTable: false,
  loadingModal: false,
};

export const turnos = {
  namespaced: true,
  state: initialState,
  actions: {
    findBySede({dispatch, commit}, {sede}) {
      //commit('loginRequest', { email });
      turnoService.findBySede(sede).then(
        data => {
          commit('setServicios', data);
        },
        error => {
          //commit('loginFailure', error);
          //dispatch('alert/error', error, { root: true });
        }
      );
    },
    findByEspecialidad({dispatch, commit}, {especialidad}) {
      //commit('loginRequest', { email });
      turnoService.findByEspecialidad(especialidad).then(
        data => {
          commit('setTurnos', data);
        },
        error => {
          //commit('loginFailure', error);
          //dispatch('alert/error', error, { root: true });
        }
      );
    },

    findByClasificacion({dispatch, commit, state}, {clasificacion}) {
      turnoService.findByTurnoClasificacion(clasificacion).then(
        data => {
            if(data.length==0){
              alert("No se encuentra programacion para este servicio ó ya se agoto la programacion para este servicio");
            }
            state.all = data; 
        },
        error => {
          commit('loginFailure', error);
          dispatch('alert/error', error, { root: true });
        }
      );
    },
    findByClasificacionKIT({dispatch, commit, state}, {clasificacion}) {
      console.log("info");
      console.log(clasificacion);
      turnoService.findByTurnoClasificacionKIT(clasificacion).then(
        data => {
            if(data.length==0){
              alert("No se encuentra programacion para este servicio ó ya se agoto la programacion para este servicio");
            }
            state.all = data; 
        },
        error => {
          commit('loginFailure', error);
          dispatch('alert/error', error, { root: true });
        }
      );
    },
    

  },
  mutations: {
    setTurnos(state, data) {
      data.forEach(value => {
        value.hora = moment(value.fecha, "HH:mm").format('LT');
        value.fecha = moment(value.fecha, "YYYY-MM-DD").format('dddd LL');
      })
      state.all = data;
    },
    setServicios(state, data) {
      data.forEach(value => {
        value.id = value.id;
        value.nombre = value.nombre;
      })
      state.servicios = data;
    },
    /*
    logout(state) {
      state.data = null;
      state.loggedIn = false;
    }
    */
  }
}



// WEBPACK FOOTER //
// ./src/store/turnos.js